module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"BIT","short_name":"BIT","start_url":"/","background_color":"#131313","theme_color":"#1986EC","display":"minimal-ui","icon":"static/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"a4ccb35c8eb2f889169c95f714322f28"},
    },{
      plugin: require('../node_modules/gatsby-plugin-gatsby-cloud/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-prismic-previews/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"biiit","accessToken":"MC5hSERrT3hFQUFDZ0FiemRF.77-977-9T--_ve-_ve-_vVJb77-9ESvvv73vv71k77-9XxJIO--_vRFaI--_ve-_ve-_vWnvv73vv71h77-9Vg"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
